import script from "./SfxInfiniteScroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxInfiniteScroll.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';import Intersection from 'quasar/src/directives/intersection/Intersection.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInfiniteScroll});qInstall(script, 'directives', {Intersection});
